import SideTool from "@/global/components/side-tool";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import TnMessage from "@/global/components/message";
import genUUID from "@/global/utils/gen-uuid";
import './index.less';
import { addGutterSection, deleteGutterSectionByUuid, findAllGutterSections, findGutterSectionsByProjectId } from "@/api/archi/gutter-section";
import { GutterSection } from "@/global/interface/archi/gutter-section";
import GutterDisplayItem from "./gutter-item/display";
import GutterEditItem from "./gutter-item/edit";

const EditChild = forwardRef(GutterEditItem);

export default function Gutter() {

    const { projectId } = useParams(); // 路由参数，项目id
    const [list, setList] = useState<GutterSection[]>([]); // 天沟截面列表
    const [selectedItem, setSelectedItem] = useState<GutterSection>(); // 当前被选择的天沟
    const [editingItem, setEditingItem] = useState<GutterSection>(); // 当前正在编辑状态的天沟
    const editRef = useRef(null);

    useEffect(() => {
        if (!projectId) return;
        getGutterSections();
    }, [projectId]) // 项目id变化时，获得天沟截面列表

    // 根据项目id获得天沟截面列表
    const getGutterSections = () => {
        // findGutterSectionsByProjectId(+projectId).then(res => {
        //     let list: GutterSection[] = res.data || [];
        //     setList(list);
        // }).catch(err => {
        //     if (err.data) {
        //         TnMessage.error(err.data);
        //     } else {
        //         TnMessage.error("获得天沟截面列表失败")
        //     }
        // })
        findAllGutterSections().then(res => {
            let list: GutterSection[] = res.data || [];
            setList(list);
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("获得天沟截面列表失败")
            }
        })
    }

    // 点击了添加按钮，新增一个天沟
    const onAdd = () => {
        // 生成一个临时uuid
        const uuid = genUUID();
        let newItem: GutterSection = {
            name: '',
            uuid: uuid,
            projectId: +projectId,
            entity: null,
        }
        // 添加天沟
        addGutterSection(+projectId, newItem).then(res => {
            setList([...list, newItem]);
            setSelectedItem(newItem);
            setEditingItem(newItem);
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("新增天沟失败")
            }
        })
    }

    // 点击了编辑按钮，编辑当前选择的天沟
    const onEdit = () => {
        if (!selectedItem) {
            TnMessage.warning("请先选中要编辑的天沟")
            return;
        }
        if (selectedItem?.uuid == editingItem?.uuid) {
            // 当前正在编辑态，再点击编辑按钮，名称又重回编辑状态
            if (editRef.current) {
                editRef.current.handleEditName();
            }
        }
        setEditingItem(selectedItem);
    }

    // 点击了删除按钮，删除当前选择的天沟
    const onDelete = () => {
        if (!selectedItem) {
            TnMessage.warning("请先选中要删除的天沟")
            return;
        }
        deleteGutterSectionByUuid(selectedItem.uuid).then(res => {
            TnMessage.success("删除成功");
            // 列表中删除当前选择的天沟
            let newList = list.filter(item => item.uuid != selectedItem.uuid);
            setList(newList);
            // 当前选择的置空
            setSelectedItem(null);
        }).catch((err) => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("删除失败");
            }
        })
    }


    return (
        <div className="gutter-container">
            <SideTool onAddClick={onAdd} onEditClick={onEdit} onDeleteClick={onDelete} />
            <div className="list-main">
                {list.map((item, index) => (
                    <div key={index} onClick={() => setSelectedItem(item)}>
                        {index != 0 && <div className="divider"></div>}
                        {item.uuid == editingItem?.uuid &&
                            <EditChild
                                ref={editRef}
                                item={item}
                                onSaveName={(name) => {
                                    item.name = name;
                                    setList([...list]);
                                }}
                                onSaveDraw={(entity) => {
                                    item.entity = entity;
                                    setList([...list]);
                                    setSelectedItem(null);
                                    setEditingItem(null);
                                }}
                            />
                        }
                        {item.uuid != editingItem?.uuid &&
                            <GutterDisplayItem
                                item={item}
                                selected={selectedItem?.uuid == item.uuid}
                            />
                        }
                    </div>
                ))}
            </div>
        </div>
    )
}